/**
 * The headline numbers for one pupil, from their loaded bundle. Shared
 * by the Home stat cards and the family overview so both always agree.
 */
export function childStats({ grades = [], attendance = [], fees = null }) {
  const graded = grades.filter((g) => g.percentage !== null && g.percentage !== undefined);
  const average = graded.length
    ? Math.round(graded.reduce((sum, g) => sum + Number(g.percentage), 0) / graded.length)
    : null;

  // "Attendance rate" counts an excused absence as present: it measures
  // unexplained absence, which is the number a parent actually cares
  // about, not raw seat time.
  const counted = attendance.filter((a) => a.status !== 'excused');
  const present = counted.filter((a) => a.status === 'present' || a.status === 'late').length;
  const rate = counted.length ? Math.round((present / counted.length) * 100) : null;

  // Three fee states, never two: exempt / no fee set / paid-or-late.
  const feesExempt = fees?.status === 'أعفاء من القسط';
  const feesNone = fees ? fees.monthly_due_cents === 0 && !feesExempt : false;
  const feesPaid = !!fees?.current_month_paid;

  return {
    average,
    rate,
    examCount: graded.length,
    absences: attendance.filter((a) => a.status === 'absent').length,
    feesExempt,
    feesNone,
    feesPaid,
  };
}

export const rateTone = (rate) =>
  rate === null ? 'info' : rate >= 90 ? 'success' : rate >= 75 ? 'warning' : 'danger';

export const feesTone = (s) => (s.feesExempt || s.feesNone ? 'info' : s.feesPaid ? 'success' : 'danger');

export const feesWord = (s) => (s.feesExempt ? 'معفى' : s.feesNone ? 'لا يوجد' : s.feesPaid ? 'مسدد' : 'متأخر');

/** "ليان سامي الأحمد" → "ليان" — what a parent calls their child. */
export const firstName = (student) => student?.first_name || String(student?.name || '').trim().split(/\s+/)[0] || '';
